// Row-density preference for the table view. Three modes:
// - comfortable (default) ~  6px row-padding
// - compact            ~  2px row-padding
// - cozy               ~  6px row-padding (slightly roomier than comfortable)
//
// Persisted in localStorage so it survives reload, and reflected on
// document.documentElement via the `data-density` attribute so the CSS in
// `styles/index.css` can scope rules to it.

import { uxEnabled } from "./ux";

export type Density = "comfortable" | "compact" | "cozy";

const STORAGE_KEY = "juuplan:density";

function isDensity(v: unknown): v is Density {
  return v === "comfortable" || v === "compact" || v === "cozy";
}

/** Standard ohne gespeicherte Wahl: mit UX-Vorschlag P6 kompakt, sonst wie bisher. */
function defaultDensity(): Density {
  return uxEnabled("ux_web_p6") ? "compact" : "comfortable";
}

export function loadDensity(): Density {
  if (typeof localStorage === "undefined") return defaultDensity();
  const raw = localStorage.getItem(STORAGE_KEY);
  return isDensity(raw) ? raw : defaultDensity();
}

export function applyDensity(d: Density): void {
  if (typeof document === "undefined") return;
  document.documentElement.dataset.density = d;
}

export function saveDensity(d: Density): void {
  if (typeof localStorage !== "undefined") {
    localStorage.setItem(STORAGE_KEY, d);
  }
  applyDensity(d);
}

/**
 * Mount-time helper. Safe to call from main.tsx OR from a useEffect inside
 * the first component that needs it. Idempotent.
 */
export function bootstrapDensity(): void {
  applyDensity(loadDensity());
}
